document.addEventListener('DOMContentLoaded', () => {
  const initialDepositInput: HTMLInputElement = document.getElementById('initial-deposit') as HTMLInputElement;
  const monthlySavingsInput: HTMLInputElement = document.getElementById('monthly-savings') as HTMLInputElement;
  const interestRateInput: HTMLInputElement = document.getElementById('interest-rate') as HTMLInputElement;
  const termYearsInput: HTMLInputElement = document.getElementById('term-years') as HTMLInputElement;

  const totalCapitalGain: HTMLElement = document.getElementById('capital-gain') as HTMLElement;
  const futureValueElement: HTMLElement = document.getElementById('future-value') as HTMLElement;
  const totalInterestEarned: HTMLElement = document.getElementById('total-interest') as HTMLElement;
  const yearlyAmountsElement: HTMLElement = document.getElementById('yearly-amounts') as HTMLElement;

  function calculateResults(): void {
    const initialDeposit: number = parseFloat(initialDepositInput.value);
    const monthlySavings: number = parseFloat(monthlySavingsInput.value);
    const annualInterestRate: number = parseFloat(interestRateInput.value) / 100;
    const termYears: number = parseInt(termYearsInput.value);

    let yearlyAmountsHTML = '';

    for (let i = 1; i <= termYears; i++) {
      let yearlyFutureValue: number =
        initialDeposit * Math.pow(1 + annualInterestRate / 12, i * 12) +
        (monthlySavings * (Math.pow(1 + annualInterestRate / 12, i * 12) - 1)) / (annualInterestRate / 12);

      yearlyFutureValue = Math.ceil(yearlyFutureValue);

      const yearlyTotalCapital: number = initialDeposit + monthlySavings * i * 12;

      const yearlyCapitalGain: number = yearlyTotalCapital - initialDeposit;

      yearlyAmountsHTML += `
                <div class="savings__calc__result-table__row">
                    <div class="savings__calc__result-table__row-item">Year ${i}</div>
                    <div class="savings__calc__result-table__row-item">£${Math.ceil(yearlyTotalCapital)}</div>
                    <div class="savings__calc__result-table__row-item">£${Math.ceil(yearlyCapitalGain)}</div>
                    <div class="savings__calc__result-table__row-item">£${Math.ceil(yearlyFutureValue)}</div>
                </div>
            `;
    }

    yearlyAmountsElement.innerHTML = yearlyAmountsHTML;

    let futureValue: number =
      initialDeposit * Math.pow(1 + annualInterestRate / 12, termYears * 12) +
        (monthlySavings * (Math.pow(1 + annualInterestRate / 12, termYears * 12) - 1)) / (annualInterestRate / 12) || 0;

    futureValue = Math.ceil(futureValue);

    const totalCapital: number = initialDeposit + monthlySavings * termYears * 12 || 0;

    const totalInterest: number = futureValue - totalCapital || 0;

    totalCapitalGain.textContent = `Total amount saved per year (excluding interest): £${Math.ceil(totalCapital)}`;
    futureValueElement.textContent = `Total saved (including interest): £${Math.ceil(futureValue)}`;
    totalInterestEarned.textContent = `Total estimated interest: £${Math.ceil(totalInterest)}`;
  }

  initialDepositInput.addEventListener('input', calculateResults);
  monthlySavingsInput.addEventListener('input', calculateResults);
  interestRateInput.addEventListener('input', calculateResults);
  termYearsInput.addEventListener('input', calculateResults);

  calculateResults();
});
